import moment from 'moment'

export const dateRegex = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/
export const dateAndTimeRegex = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[ ]?(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/
export const timeRegex = /\d\d:\d\d/
export const dateFormat = 'YYYY/MM/DD'
export const timeFormat = 'HH:mm'
export const regexNumberAndComma = /^-?\d+\.?\d*$/
export const positiveNumberRegex = /^[1-9]\d*$/

export function dateTimeToTimestamp(dateTime: string): number {
    return parseInt(moment(moment(dateTime, `${dateFormat} ${timeFormat}`)).format('x'))
}

export function timestampToDateTime(ts?: number | Date | string): { date: string; time: string } {
    const date = moment(ts)

    return {
        date: date.format(dateFormat),
        time: date.format(timeFormat)
    }
}

export const calculateLinearInterpolation = (x, x0, y0, x1, y1) => {
    return y0 + ((x - x0) * (y1 - y0)) / (x1 - x0)
}
